module.exports = __webpack_public_path__ + "static/img/banner.16822a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/banner.png
// module id = geFG
// module chunks = 1